export default __webpack_public_path__ + "static/media/headerContacto.a326ddef.png";